// @ts-nocheck

import { Paragraph } from 'applaus-ui-kit'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import { ReduxState } from '../../redux/rootReducer'
import { LocationModal } from '../locationModal/LocationModal'
import locationJson from '../locationModal/location.json'
import { getLocationDisplayLabel } from '../../utils/normalizeLocation'
import * as S from './MobileLocationBar.styles'

export const MobileLocationBar = () => {
  const { location } = useSelector((state: ReduxState) => state.UserReducer)
  const [locationModalOpen, setLocationModalOpen] = useState(false)
  const stateOptions = locationJson.estados.map((state) => ({
    value: state.sigla,
    label: state.nome
  }))
  const displayLocation =
    getLocationDisplayLabel(location, stateOptions) ?? 'Escolha sua localização'

  return (
    <>
      <S.Container
        role="button"
        tabIndex={0}
        aria-label={`Localização: ${displayLocation}. Toque para alterar.`}
        onClick={() => setLocationModalOpen(true)}
        onKeyDown={(event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault()
            setLocationModalOpen(true)
          }
        }}>
        <S.LocationWrapper>
          <S.LocationIcon />
          <Paragraph variant="regular">{displayLocation}</Paragraph>
          <S.ChevronDownIcon className="chevronIcon" />
        </S.LocationWrapper>
      </S.Container>
      <LocationModal
        isOpen={locationModalOpen}
        handleClose={() => setLocationModalOpen(false)}
      />
    </>
  )
}
